import React from 'react';

export default function apiForm(WrappedComponent, defaultState) {
    return class extends React.PureComponent {
        constructor(props) {
            super(props);

            this.state = {
                pending: false,
                invalid: [],
                errors: [],
                submitted: false,
                values: {},
                ...defaultState,
            };
        }

        parseResponseErrors = (response) => {
            const invalid = [];
            const errors = [];

            if (response.status !== 'success') {
                const rawErrors = response.data;
                if (rawErrors) {
                    Object.keys(rawErrors).forEach((field) => {
                        invalid.push(field);
                        errors.push(rawErrors[field]);
                    });
                } else {
                    errors.push('Ошибка при отправке формы.');
                }
            }

            return { invalid, errors };
        };

        clearErrors = () => {
            this.setState({ invalid: [], errors: [] });
        };

        pushError = (error, field) => {
            this.setState({ errors: this.state.errors.concat(error) });
            if (field) {
                this.setState({ invalid: this.state.invalid.concat(field) });
            }
        };

        beforeSubmit = () => {
            this.setState({ submitted: false, pending: true, errors: [], invalid: [] });
        };

        afterSubmit = (response) => {
            const { errors, invalid } = this.parseResponseErrors(response);

            this.setState({
                pending: false,
                invalid,
                errors,
                submitted: true,
            });
        };

        serializeForm = (form) => {
            const serialized = {};

            if (form.elements) {
                for (let i = 0; i < form.elements.length; i++) {
                    const field = form.elements[i];
                    // Don't serialize fields without a name, submits, buttons, file and reset inputs, and disabled fields
                    if (
                        !field.name ||
                        field.disabled ||
                        field.type === 'file' ||
                        field.type === 'reset' ||
                        field.type === 'submit' ||
                        field.type === 'button'
                    )
                        continue;

                    // Convert field data to a query string
                    if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
                        serialized[field.name] = field.value;
                    }
                }
            }

            return {
                ...serialized,
                ...this.state.values,
            };
        };

        onInputChange = (fieldName, e) => {
            const value = typeof e === 'object' ? e.currentTarget.value : e;

            this.setState({
                values: {
                    ...this.state.values,
                    [fieldName]: value,
                },
            });
        };

        render() {
            return (
                <WrappedComponent
                    beforeSubmit={this.beforeSubmit}
                    afterSubmit={this.afterSubmit}
                    clearErrors={this.clearErrors}
                    pushError={this.pushError}
                    onInputChange={this.onInputChange}
                    serializeForm={this.serializeForm}
                    formState={this.state}
                    {...this.props}
                />
            );
        }
    };
}



// WEBPACK FOOTER //
// ./components/Form/apiForm.jsx